// AR
export const hotelRoomsManager = {
  header: {
    eyebrow: "غرف الفندق",
    title: "إدارة الغرف",
    subtitle:
      "أنشئ أنواع الغرف وولّد الوحدات الفعلية بأرقامها. ستتم مزامنة هذه الغرف مع Channex.",
    addRoom: "إضافة غرفة",
  },
  states: {
    loading: "جارٍ تحميل الغرف...",
    emptyTitle: "لا توجد غرف بعد",
    emptySubtitle:
      "أنشئ أول نوع غرفة لبدء إعداد الأسعار والإتاحة في Channex.",
    addFirstRoom: "إضافة أول غرفة",
  },
  card: {
    roomsBadge: "{count} غرفة | {count} غرف",
    maxGuests: "الحد الأقصى {count} نزيل",
    editTitle: "تعديل الغرفة",
    deleteTitle: "حذف الغرفة",
    adults: "{count} بالغ | {count} بالغين",
    children: "{count} طفل | {count} أطفال",
    infants: "{count} رضيع | {count} رُضّع",
    units: "الوحدات",
  },
  physical: {
    title: "الغرف الفعلية",
    subtitle:
      "عدّل رقم كل غرفة أو اسمها، أو انقلها إلى نوع آخر. تنتقل حجوزاتها معها. اسحبها من المقبض لترتيبها داخل نوعها: هذا هو الترتيب الذي ستراه في التقويم.",
    roomsCount: "{count} غرفة | {count} غرف",
    savingOrder: "جارٍ حفظ الترتيب…",
    selectAll: "تحديد الكل",
    clearSelection: "إلغاء التحديد",
    dragToOrder: "اسحب لإعادة الترتيب",
    selectRoom: "تحديد {label}",
    roomFallback: "غرفة",
    codePlaceholder: "رقم / رمز",
    namePlaceholder: "الاسم",
  },
  bar: {
    selectedCount: "غرفة محدَّدة | غرف محدَّدة",
    clearSelection: "إلغاء التحديد",
    changeType: "تغيير النوع",
  },
  modal: {
    createTitle: "غرفة جديدة",
    editTitle: "تعديل الغرفة",
    createSubtitle: "حدّد النوع وولّد الوحدات الفعلية",
    editSubtitle: "حدّث بيانات نوع الغرفة",
    basicInfo: "المعلومات الأساسية",
    nameLabel: "اسم الغرفة",
    namePlaceholder: "مثال: غرفة مزدوجة، جناح جونيور…",
    descriptionLabel: "الوصف",
    optional: "(اختياري)",
    descriptionPlaceholder: "إطلالة على البحر، شرفة، ميني بار…",
    inventorySection: "المخزون والسعة",
    countLabel: "عدد الغرف",
    countHintZero:
      "تُنشأ دون أي غرفة: يمكنك بعد ذلك تعيين غرف موجودة لها من قائمة الغرف الفعلية.",
    countHint: "إجمالي الوحدات الفعلية من هذا النوع",
    capacityLabel: "السعة الإجمالية (النزلاء)",
    capacityHint: "الحد الأقصى المسموح بين البالغين + الأطفال + الرُّضّع",
    priceLabel: "السعر لكل ليلة",
    priceHint:
      "بهذا يتم إنشاء سعرها القياسي. يمكنك ضبطه لاحقًا في «أسعار الفندق».",
    adultsLabel: "البالغون",
    childrenLabel: "الأطفال",
    infantsLabel: "الرُّضّع",
    numberingSection: "ترقيم الغرف",
    toggleOn: "مُفعّل",
    toggleOff: "مُعطّل",
    numberingHintCreate:
      "تُنشأ الغرف برمز تلقائي. يمكنك تغييره واحدة تلو الأخرى في قائمة الغرف الفعلية، أو تثبيت الترقيم من «تعديل» لتنشأ الغرف التالية به.",
    prefixLabel: "بادئة الرمز",
    prefixPlaceholder: "مثال: 10  أو  A-",
    prefixHint: 'مثال: البادئة "10" + البداية 1 → 101, 102…',
    startNumberLabel: "رقم البداية",
    paddingLabel: "الحشو",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "أسماء الغرف الفعلية",
    nameModeType: "النوع فقط",
    nameModeTypeExample: "مزدوجة",
    nameModeTypeCode: "النوع + الرمز",
    nameModeTypeCodeExample: "مزدوجة 101",
    preview: {
      lead: "سيتم إنشاء",
      roomsNoun: "غرفة | غرف",
      withNumbering: "بهذا الترقيم. مثال:",
    },
    numberingHintKeep:
      "تحتفظ الغرف الموجودة برقمها. سيُطبَّق هذا الترقيم على الغرف التي تضيفها من الآن فصاعدًا.",
    numberingHintZero:
      "بدون غرف لا يوجد ما يُرقَّم. عيّن لها غرفًا موجودة من قائمة الغرف الفعلية.",
    numberingHintDisabled:
      "لن تُولَّد الغرف الفعلية تلقائيًا. يمكنك تفعيل ذلك متى شئت.",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    creating: "جارٍ الإنشاء…",
    saveChanges: "حفظ التغييرات",
    createRoom: "إنشاء غرفة",
  },
  delete: {
    title: "حذف الغرفة",
    subtitle: "لا يمكن التراجع عن هذا الإجراء",
    confirmCopy: "اكتب اسم الغرفة للتأكيد:",
    placeholder: "اسم الغرفة",
    cancel: "إلغاء",
    deleting: "جارٍ الحذف...",
    confirm: "حذف",
  },
  change: {
    title: "تغيير النوع {target}",
    subtitle: "لا يتغيّر رقم الغرفة",
    newTypeLabel: "النوع الجديد",
    newTypePlaceholder: "اختر النوع الذي تنتقل إليه…",
    blocksHead: "حجز واحد يمنع التغيير | {count} حجوزات تمنع التغيير",
    moves: "تنتقل إلى النوع الجديد",
    stays: "تبقى في نوعها الحالي",
    addMissing: "أضف {labels} إلى التغيير وأعد المحاولة",
    stockLabel: "الغرف المعروضة للبيع",
    checkingReservations: "جارٍ التحقق من الحجوزات الموجودة في {target}…",
    thisRoom: "هذه الغرفة",
    theseRooms: "هذه الغرف",
    theRoom: "الغرفة",
    theRooms: "الغرف",
    noReservations: "لا توجد أي حجوزات في {target}.",
    reservationsLeave: "حجز ينتقل | حجوزات تنتقل",
    with: "مع {target}",
    moreReservations: "و{count} حجز إضافي | و{count} حجوزات إضافية",
    greyLegend: "الغرف باللون الرمادي تبقى في نوعها الحالي.",
    retry: "إعادة المحاولة",
    cancel: "إلغاء",
    applying: "جارٍ التغيير…",
    confirm: "نعم، غيّر النوع",
    titleTargetOne: "للغرفة {label}",
    titleTargetMany: "لـ {count} غرفة | لـ {count} غرف",
    textZero: "هذه الغرف من ذلك النوع بالفعل: اختر نوعًا آخر لنقلها.",
    textOne:
      "تحتفظ الغرفة برقمها وبحجوزاتها: يتغيّر فقط النوع الذي تُباع به. حيث هي الآن ستقل غرفة واحدة عن البيع، وفي النوع الجديد ستزيد واحدة.",
    textMany:
      "تحتفظ الغرف الـ {count} برقمها وبحجوزاتها: يتغيّر فقط النوع الذي تُباع به. حيث هي الآن ستقل {count} غرف عن البيع، وفي النوع الجديد ستزيد {count}.",
  },
  blockTitles: {
    huespedDentro: "يوجد نزيل مقيم",
    reservaRepartida: "الحجز يشغل غرفًا أخرى",
    reservaSinAsignar: "الحجز لا يضم كل غرفه",
    fallback: "لا يمكن النقل",
  },
  groups: {
    noType: "دون نوع محدَّد",
  },
  reservation: {
    noName: "بدون اسم",
  },
  toasts: {
    roomsChanged: "تم تغيير نوع الغرفة | تم تغيير نوع {count} غرف",
    changedSyncing: "{done} · جارٍ تحديث القنوات",
    created: "تم إنشاء الغرفة بنجاح",
    updated: "تم تحديث الغرفة",
    deleted: "تم حذف الغرفة",
  },
  errors: {
    generic: "حدث خطأ ما.",
    loadRooms: "خطأ في تحميل الغرف",
    updateQty: "تعذّر تحديث الكمية",
    savePhysicalRoom: "تعذّر حفظ الغرفة",
    saveOrder: "تعذّر حفظ ترتيب الغرف.",
    checkReservations: "تعذّر التحقق من الحجوزات الموجودة في هذه الغرف.",
    changeType: "تعذّر تغيير نوع الغرفة.",
    noProperty: "تعذّر الحصول على مكان الإقامة. حاول مرة أخرى.",
    saveRoom: "خطأ في حفظ الغرفة",
    deleteRoom: "خطأ في الحذف",
  },
};
